import { render, staticRenderFns } from "./CompanyLinks.vue?vue&type=template&id=6ca9ece7"
import script from "./CompanyLinks.vue?vue&type=script&lang=js"
export * from "./CompanyLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports